import appStore from 'store';
import api from './api';

const store = {

    namespaced: true,

    state: {
        /**支持充值的币种*/
        supportCoinDeposit:[],
        /**支持内部转账的币种*/
        supportCoinTransfer:[],
        transferTotal:0,
        transferInfo:[],
    },

    mutations: {
        setSupportCoinDeposit(state,payload) {
            state.supportCoinDeposit = payload;
        },
        setSupportCoinTransfer(state,payload) {
            state.supportCoinTransfer = payload;
        },
        setTransferTotal(state,payload) {
            state.transferTotal = payload;
        },
        setTransferInfo(state,payload) {
            state.transferInfo = payload;
        }
    },

    actions: {
        getSupportDepositCoinType({commit}) {
           return new Promise(resolve => {
                api.getSupportCoinDeposit().then(response => {
                    commit('setSupportCoinDeposit',response.data);
                    resolve(response.data);
                })
            })
        },

        getSupportTransferCoinType({commit}) {
           return new Promise(resolve => {
               api.getSupportCoinTransfer().then(response => {
                   commit('setSupportCoinTransfer',response.data);
                   resolve(response.data);
               })
           })
        },

        balanceChangeWallet({commit},data) {
            return api.balanceChangeForWallet(data);
        },

        balanceChangeInternalTransfer({commit},data) {
            return api.balanceChangeForInternalTransfer(data);
        },

        queryTransferList({commit},data){
            api.selectTransferInfo(data).then(response => {
                commit('setTransferInfo', response.data.list);
                commit('setTransferTotal', response.data.totalCount);
            })
        }
    }
}

appStore.registerModule('airdropUpload',store);
